import { useCallback, useId } from "react";
import { useTranslation } from "react-i18next";
import { useMatchAllTermsContext } from "@/features/match-all-terms";
import { useTrackSearchFormInteraction } from "@/shared/lib/ube";
import styles from "./MatchAllTerms.module.scss";

export const MatchAllTerms = () => {
    const { t } = useTranslation();
    const id = useId();
    const { matchAllTermsExactly, setMatchAllTermsExactly } = useMatchAllTermsContext();
    const track = useTrackSearchFormInteraction();

    const onInputChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            track({ action: e.target.checked ? "check" : "uncheck", objectName: "match_all_terms" });
            setMatchAllTermsExactly(e.target.checked);
        },
        [setMatchAllTermsExactly, track],
    );

    return (
        <div className={styles.matchAllTerms}>
            <input
                id={id}
                data-testid="SFS_matchAllTermsInput"
                className="checkbox"
                type="checkbox"
                checked={matchAllTermsExactly}
                onChange={onInputChange}
            />
            <label htmlFor={id}>{t("matchAllTermsExactly")}</label>
        </div>
    );
};
